window.addEventListener('load', () => {
  // プレビュー画面の場合はなにもしない
  if (document.getElementsByClassName('preview-header').length) return

  var itemListElements = new Array()
  var breadcrumb__items = document.getElementsByClassName('breadcrumb__item')
  // ぱんくずリストが存在しない場合はなにもしない
  if (!breadcrumb__items.length) return

  // ぱんくずリストのマークアップ作成
  for (var i = 0; i < breadcrumb__items.length; i++) {
    var itemListElement = { '@type': 'ListItem' }
    itemListElement.position = i + 1
    itemListElement.name = breadcrumb__items[i].innerText.trim()
    var link_element = breadcrumb__items[i].getElementsByClassName('breadcrumb__link')
    if (link_element.length > 0) {
      itemListElement.item = location.protocol + '//' + location.host + link_element[0].getAttribute('href')
    }
    itemListElements.push(itemListElement)
  }

  var breadcrumb_markup = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: itemListElements,
  }

  var script = document.createElement('script')
  script.setAttribute('type', 'application/ld+json')
  script.innerText = JSON.stringify(breadcrumb_markup)
  document.head.appendChild(script)
})
